import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Hero.css';
import ThreeBackground from './ThreeBackground';

interface HeroProps {
    connectionCount?: number;
}

const Hero: React.FC<HeroProps> = ({ connectionCount = 0 }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
    }, []);

    return (
        <div className="hero-container">
            <ThreeBackground />
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <p className="hero-keywords">IoT · 피지컬 AI · 온디바이스 AI · 데이터 사이언스</p>
                <h1 className="hero-title">i2r IoT PLC & 센서</h1>
                <p className="hero-subtitle">IoT · 피지컬 AI · 온디바이스 AI 기반의 스마트 공장 자동화 솔루션</p>

                {/* Connection Count Display */}
                <div style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '8px 20px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: '30px',
                    marginBottom: '40px',
                    marginTop: '20px',
                    border: '1px solid rgba(255, 255, 255, 0.2)',
                    color: '#fff',
                    fontFamily: 'monospace',
                    fontSize: '1rem',
                    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)'
                }}>
                    <span style={{
                        display: 'block',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: '#00ff00',
                        boxShadow: '0 0 10px #00ff00',
                        animation: 'pulse 2s infinite'
                    }}></span>
                    <span style={{ letterSpacing: '0.5px' }}>Live Devices: <strong>{connectionCount}</strong></span>
                </div>

                <style>
                    {`
                        @keyframes pulse {
                            0% { opacity: 1; transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 255, 0, 0.7); }
                            70% { opacity: 0.7; transform: scale(1.1); box-shadow: 0 0 0 10px rgba(0, 255, 0, 0); }
                            100% { opacity: 1; transform: scale(1); box-shadow: 0 0 0 0 rgba(0, 255, 0, 0); }
                        }
                    `}
                </style>

                <div className="hero-btns">
                    {isLoggedIn ? (
                        <Link to="/overview" className="btn btn-primary">
                            대시보드 보기
                        </Link>
                    ) : (
                        <a href="#dashboard-preview" className="btn btn-primary">
                            대시보드 보기
                        </a>
                    )}
                    <a href="#products" className="btn btn-outline">
                        제품 살펴보기
                    </a>
                    <a href="https://github.com/kdi6033" target="_blank" rel="noreferrer" className="btn btn-outline">
                        문서 보기(GitHub)
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
